import FJActionCommon from '../../../redux/action/FJActionCommon';
import FJActionModal from '../../../redux/action/FJActionModal';
import FJMobileGenerateSuccessful from './FJMobileGenerateSuccessful';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { setSliceMobileGenerateSuccessPreviewIndex } from '../../../redux/slices/FJSliceCommon';

const FJMobileGenerateSuccessfulContainer = props => {
    const { gotoBack, onReEdit, gotoBackText, previewList, reEditText, imageRect = {}, reEditHasUpload = true } = props;
    useLocalStore();
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const previewIndex = useSelector(state => state.common.mobileGenerateSuccessPreviewIndex);
    const onPreview = useCallback(
        data => {
            dispatch(
                FJActionModal.showPreviewModalDataAction({
                    data,
                    previewList: previewList,
                    isShowOrder: previewList.length > 1,
                }),
            );
        },
        [dispatch, previewList],
    );
    const onDownload = useCallback(
        callback => {
            dispatch(
                FJActionCommon.multiDownloadAction(
                    previewList.map(i => i.id),
                    'preview',
                    callback,
                ),
            );
        },
        [dispatch, previewList],
    );
    const setPreviewIndex = useCallback(
        index => {
            dispatch(setSliceMobileGenerateSuccessPreviewIndex(index));
        },
        [dispatch],
    );
    return (
        <FJMobileGenerateSuccessful
            onDownload={onDownload}
            gotoBack={gotoBack}
            onReEdit={onReEdit}
            onPreview={onPreview}
            taskStatus={taskStatus}
            gotoBackText={gotoBackText}
            previewList={previewList}
            reEditText={reEditText}
            imageRect={imageRect}
            reEditHasUpload={reEditHasUpload}
            previewIndex={previewIndex}
            setPreviewIndex={setPreviewIndex}
        />
    );
};
FJMobileGenerateSuccessfulContainer.propTypes = {
    gotoBack: PropTypes.func,
    onReEdit: PropTypes.func,
    previewList: PropTypes.array,
    gotoBackText: PropTypes.string,
    reEditText: PropTypes.string,
    imageRect: PropTypes.object,
    reEditHasUpload: PropTypes.bool,
    isShowOrder: PropTypes.bool,
};

export default FJMobileGenerateSuccessfulContainer;
